// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a31fbad7","513":"442a6015","703":"54c87599","787":"60b87115"}[chunkId] + ".chunk.js";
};